import { type Metric, onCLS, onFCP, onINP, onLCP, onTTFB } from 'web-vitals'

function sendToAnalytics(metric: Metric): void {
  if (import.meta.env.DEV) {
    console.log('[web-vitals]', metric.name, metric.value)
    return
  }
  // /api/telemetry/web-vitals — future backend endpoint (see plan §T6.5).
  // navigator.sendBeacon synchronously enqueues; failure is silent (acceptable for telemetry).
  const payload = JSON.stringify({
    name: metric.name,
    value: metric.value,
    id: metric.id,
    rating: metric.rating,
    delta: metric.delta,
  })
  if (typeof navigator !== 'undefined' && 'sendBeacon' in navigator) {
    navigator.sendBeacon('/api/telemetry/web-vitals', payload)
  }
}

export function initWebVitals(): void {
  onCLS(sendToAnalytics)
  onINP(sendToAnalytics)
  onLCP(sendToAnalytics)
  onFCP(sendToAnalytics)
  onTTFB(sendToAnalytics)
}
